import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { mergeClasses } from "@lib/css"

import { PureLogo } from "../molecules"

import type { ReactElement } from "react"

type LogoProps = {
  children?: ReactElement
  classes?: {
    container?: string
    logo?: string
  }
  disabled?: boolean
}

export const Logo = observer(function Logo(props: LogoProps) {
  const { children, classes = {}, disabled = false } = props
  const {
    GlobalModel: { config, lang },
  } = useStore()

  const defaultContainerClasses =
    "space-x-2 flex items-start flex-shrink-0 mobile-m:space-x-2.5 mobile-m:w-auto tablet:space-x-5"
  const containerClasses = mergeClasses(
    defaultContainerClasses,
    classes.container,
  )

  if (disabled) {
    return (
      <div className={containerClasses}>
        <PureLogo className={classes.logo} />
        {children}
      </div>
    )
  }

  return (
    <div className={containerClasses}>
      <a href={`${config.siteUrl}/${lang === "zh" ? "ch" : lang}/`}>
        <PureLogo className={classes.logo} />
      </a>
      {children}
    </div>
  )
})
